export function isIntegrationFieldEmpty (field, value) {
  if (field === 'location_id' || field === 'orders_location_id') {
    return value === null || value === undefined || value === ''
  }
  return value === null || value === undefined || String(value).trim() === ''
}

export function hasIntegrationFieldError ({
  field,
  validationErrors,
  showFieldValidation,
  requiredFields,
  formData
}) {
  if (validationErrors && validationErrors[field]) return true
  if (!showFieldValidation) return false
  if (!(requiredFields || []).includes(field)) return false
  return isIntegrationFieldEmpty(field, formData ? formData[field] : undefined)
}

export function getIntegrationFieldErrorMessage ({
  field,
  validationErrors,
  showFieldValidation,
  requiredFields,
  formData,
  requiredMessage
}) {
  if (validationErrors && validationErrors[field]) {
    return validationErrors[field]
  }
  if (hasIntegrationFieldError({
    field,
    validationErrors,
    showFieldValidation,
    requiredFields,
    formData
  })) {
    return requiredMessage
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Integrations/integrationFormFieldHelpers.js